import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import { withFirebase } from "../../components/Firebase/Firebase";
import CompetitionItem from "../../components/CompetitionItem/CompetitionItem";
import Button from "../../components/Button/Button";
import Loading from "../../components/Loading/Loading";

class AdminCompetitions extends Component {
  componentDidMount() {
    this.props.methods.getCompetitions();
  }
  routeToNewCompetition = () => {
    this.props.history.push(`/admin/competition/new`);
  };
  render() {
    return (
      <PageWrapper admin context="competition-admin">
        {!this.props.competitions ? (
          <Loading />
        ) : (
          Object.keys(this.props.competitions).map(competitionId => (
            <CompetitionItem
              id={competitionId}
              key={competitionId}
              competition={this.props.competitions[competitionId]}
            />
          ))
        )}
        <Button onClick={this.routeToNewCompetition}>New Competition</Button>
      </PageWrapper>
    );
  }
}

export default withRouter(withFirebase(AdminCompetitions));



// WEBPACK FOOTER //
// ./src/pages/Admin/AdminCompetitions.js